import { render } from "./ImageContainer.vue?vue&type=template&id=c32a60a0"
import script from "./ImageContainer.vue?vue&type=script&lang=js"
export * from "./ImageContainer.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\Ned-ie\\ned_website-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__